<bb-transaction-signing-error *ngIf="error; else displayForm"
  [error]="error"
  (close)="acceptError.emit($event)">
</bb-transaction-signing-error>

<ng-template #displayForm>
  <form [formGroup]="form" (submit)="onComplete()" class="bb-block bb-block--md">
    <label [for]="ids['select-device-control']"
      i18n="Select device text@@bb-oob-select-device-signing.text.label">
      Select the device you would like to sign this transaction with.
    </label>
    <p>
      <small i18n="Devices ordered text@@bb-oob-select-device-signing.text.hint">
        (Devices ordered by most recent registered)
      </small>
    </p>

    <div class="form-group">
      <bb-dropdown-single-select-ui
        data-role="ts-select-device-control"
        [id]="ids['select-device-control']"
        i18n-placeholder="Select device placeholder@@bb-oob-select-device-signing.input.select-placeholder"
        placeholder="Select a device..."
        formControlName="device"
        [required]="true">
        <ng-container *ngIf="challengeData && challengeData.devices">
          <ng-container *ngFor="let device of challengeData.devices">
            <bb-dropdown-single-select-option-ui *ngIf="deviceHasFriendlyName(device); else noFriendlyNameDevice"
              data-role="ts-oob-select-device-option-with-name"
              [label]="device.friendlyName"
              [value]="device">
            </bb-dropdown-single-select-option-ui>

            <ng-template #noFriendlyNameDevice>
              <ng-container *ngIf="device.vendor && device.model; then displayVendorModelDevice else displayUnknownDevice"></ng-container>
            </ng-template>

            <ng-template #displayVendorModelDevice>
              <bb-dropdown-single-select-option-ui
                data-role="ts-oob-select-device-option-with-vendor-model"
                [label]="deviceGetVendorModelName(device)"
                [value]="device">
              </bb-dropdown-single-select-option-ui>
            </ng-template>
            <ng-template #displayUnknownDevice>
              <bb-dropdown-single-select-option-ui
                data-role="ts-oob-select-device-option-without-name"
                label="Unknown Device"
                i18n-label="Select device unknown option@@bb-oob-select-device-signing.input.select-option-unknown"
                [value]="device">
              </bb-dropdown-single-select-option-ui>
            </ng-template>

          </ng-container>
        </ng-container>
      </bb-dropdown-single-select-ui>
      <bb-input-validation-message-ui [showErrors]="showErrors">
        <span *ngIf="showDeviceNotChosenError"
          data-role="ts-oob-select-device-missing-error"
          i18n="Device not chosen error message@@bb-oob-select-device-signing.errors.missing">
          You must choose a device.
        </span>
      </bb-input-validation-message-ui>
    </div>

    <p>
      <strong i18n="Selected device action description@@bb-oob-select-device-signing.text.selected-action-description"
        data-role="ts-select-device-validation-message">
        Your selected device will be sent a notification to sign the transaction.
      </strong>
    </p>
    <hr />
    <p>
      <small i18n="Navigation away notice@@bb-oob-select-device-signing.text.navigation-away">
        Note: Navigation away from this modal will result in a cancellation of this transaction signing process.
      </small>
    </p>

    <div class="bb-button-bar">
      <button bbButton
        data-role="ts-select-device-continue"
        class="bb-button-bar__button"
        color="primary"
        type="submit"
        i18n="Complete button@@bb-oob-select-device-signing.complete">
        Continue
      </button>
      <button bbButton
        data-role="ts-select-device-cancel"
        class="bb-button-bar__button"
        color="secondary"
        (click)="onCancel()"
        i18n="Cancel button@@bb-oob-select-device-signing.cancel">
        Cancel transaction
      </button>
    </div>
  </form>
</ng-template>
